module.exports = __webpack_public_path__ + "media/images/Disclosure-fa52b62a705f975a5e97e4f3b820e5c7.svg";